/**
 * Centralized API Configuration
 * All API endpoints are defined here using a single base URL
 * This eliminates redundant environment variables and makes it easy to manage endpoints across dev/prod environments
 */

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_ENDPOINTS = {
  // Mismatch & Team Performance
  MISMATCH: `${BASE_URL}/servicenow-reports`,
  TEAM_PERFORMANCE: `${BASE_URL}/servicenow-reports`,
  
  // EFTS APIs
  EFTS: `${BASE_URL}`,
  
  // Job Scheduler
  JOB_SCHEDULER: `${BASE_URL}`,
  
  // Document Search
  DOCSEARCH_PC: `${BASE_URL}`,
  DOCSEARCH_BC: `${BASE_URL}`,
  DOCSEARCH_CC: `${BASE_URL}`,
  
  // Message & Incident Management
  MESSAGE_QUEUES: `${BASE_URL}`,
  INCIDENTS: `${BASE_URL}`,
  RABBITMQ: `${BASE_URL}`,
  BATCH_QUEUES: `${BASE_URL}`,
  
  // Agent & Reports
  AGENT_SMITH: `${BASE_URL}`,
  L2_AGENT_SMITH: `${BASE_URL}`,
  AGENT_SMITH_READ: `${BASE_URL}/agent-smith/read`,
  GW_BUGFIX_LAMBDA: `${BASE_URL}/trinity`,
  GW_BUGFIX_AGENTCORE_ARN: process.env.REACT_APP_GW_BUGFIX_AGENTCORE_ARN,
  GW_BUGFIX_AGENTCORE_ARN_SGI: process.env.REACT_APP_GW_BUGFIX_AGENTCORE_ARN_SGI,
  AGENTCORE_ARN_PEEL: process.env.REACT_APP_AGENTCORE_ARN_PEEL,
  AGENTCORE_ARN_PMIC: process.env.REACT_APP_AGENTCORE_ARN_PMIC,
  AGENTCORE_ARN_SGI: process.env.REACT_APP_AGENTCORE_ARN_SGI,
  SPRINGBOOT_API: `${BASE_URL}`,
  VPN_CHECK: `${BASE_URL}`,
  REPORTS: `${BASE_URL}/reports`,
  DASHBOARD_DATA: `${BASE_URL}`,
  HEALTH_CHECK: `${BASE_URL}`,
  DATA_VALIDATOR: `${BASE_URL}`,
  DIGITAL_TESTS: `${BASE_URL}`,
  TREND_QUERIES: `${BASE_URL}`,
  
  // Email Service
  EMAIL: `${BASE_URL}/email-service`,
  // Runtime feedback catalog (configured once; catalog contents are fetched at runtime)
  FEEDBACK_CATALOG: process.env.REACT_APP_FEEDBACK_CATALOG_URL,
  
  // AgentCore (externally hosted)
  AGENTCORE_URL: process.env.REACT_APP_AGENTCORE_URL,

  // Pretriage review API (authenticated review and immediate application dispatch)
  PRETRIAGE: `${BASE_URL}/pretriage`,

  // NEO QA Agent
  // Local dev: Flask local_server.py on port 8001
  // Prod: same AGENTCORE_URL base, different ARN (REACT_APP_NEO_AGENTCORE_ARN)
  NEO: process.env.REACT_APP_NEO_API_URL || 'http://localhost:8001',
  NEO_AGENTCORE_ARN: process.env.REACT_APP_NEO_AGENTCORE_ARN,
};

/**
 * Helper function to build full endpoint URLs with subpaths
 * @param {string} endpoint - The base endpoint from API_ENDPOINTS
 * @param {string} subpath - Optional subpath to append
 * @returns {string} Full API URL
 */
export const buildApiUrl = (endpoint, subpath = '') => {
  return subpath ? `${endpoint}${subpath}` : endpoint;
};

/**
 * Helper function to get base URL
 * @returns {string} The base API URL
 */
export const getBaseUrl = () => BASE_URL;
